import { render, staticRenderFns } from "./CoordinatesInfo.vue?vue&type=template&id=6382c340&scoped=true&"
import script from "./CoordinatesInfo.vue?vue&type=script&lang=ts&"
export * from "./CoordinatesInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CoordinatesInfo.vue?vue&type=style&index=0&id=6382c340&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6382c340",
  null
  
)

export default component.exports